/**
 * @generated SignedSource<<0bc9750964907e16cc760b838fb856b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetNoteEditingMode = "DEFAULT" | "READ_ONLY";
export type WidgetNoteFontSize = "LARGE" | "MEDIUM" | "SMALL";
export type WidgetNoteFontStyle = "BOLD" | "CURSIVE" | "DEFAULT";
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type PreviewWidgetNoteInput = {
  id: string;
  pages: ReadonlyArray<WidgetNotePreviewPageInput>;
  size: WidgetOverviewSize;
  storecastId?: string | null;
  title: string;
};
export type WidgetNotePreviewPageInput = {
  backgroundColor?: string | null;
  currentValue: string;
  fontSize: WidgetNoteFontSize;
  fontStyle: WidgetNoteFontStyle;
  id: string;
  imageScale?: number | null;
  imageTranslateX?: number | null;
  imageTranslateY?: number | null;
  includedInSlideshow: boolean;
  remoteImageURL?: string | null;
};
export type WANotePreviewQuery$variables = {
  input: PreviewWidgetNoteInput;
  storecastId: string;
};
export type WANotePreviewQuery$data = {
  readonly dashboard: {
    readonly previewWidgetNote: {
      readonly " $fragmentSpreads": FragmentRefs<"WidgetNote_widgetNote">;
    };
  };
};
export type WANotePreviewQuery$rawResponse = {
  readonly dashboard: {
    readonly id: string;
    readonly previewWidgetNote: {
      readonly id: string;
      readonly note: {
        readonly editingMode: WidgetNoteEditingMode;
        readonly id: string;
        readonly isOrgNote: boolean;
        readonly noteSize: WidgetNoteSize;
        readonly pages: ReadonlyArray<{
          readonly backgroundColor: string | null;
          readonly containImage: boolean | null;
          readonly currentValue: string;
          readonly fontColor: string | null;
          readonly fontSize: WidgetNoteFontSize;
          readonly fontStyle: WidgetNoteFontStyle;
          readonly id: string;
          readonly image: {
            readonly id: string;
            readonly largeImage: {
              readonly height: number;
              readonly id: string;
              readonly url: string;
              readonly width: number;
            } | null;
          } | null;
          readonly imageScale: number | null;
          readonly imageTranslateX: number | null;
          readonly imageTranslateY: number | null;
          readonly includedInSlideshow: boolean;
          readonly remoteImageURL: string | null;
          readonly version: string;
        }>;
        readonly title: string;
      };
    };
  } | null;
};
export type WANotePreviewQuery = {
  rawResponse: WANotePreviewQuery$rawResponse;
  response: WANotePreviewQuery$data;
  variables: WANotePreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WANotePreviewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v2/*: any*/),
              "concreteType": "WidgetNote",
              "kind": "LinkedField",
              "name": "previewWidgetNote",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetNote_widgetNote"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WANotePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "WidgetNote",
            "kind": "LinkedField",
            "name": "previewWidgetNote",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "editingMode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOrgNote",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetNotePage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": "largeImage",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "minHeight",
                                "value": 1080
                              },
                              {
                                "kind": "Literal",
                                "name": "minWidth",
                                "value": 1080
                              }
                            ],
                            "concreteType": "ImageSize",
                            "kind": "LinkedField",
                            "name": "size",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "height",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "width",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": "size(minHeight:1080,minWidth:1080)"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fontColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "includedInSlideshow",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "backgroundColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "version",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fontSize",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fontStyle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageScale",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageTranslateX",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageTranslateY",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "remoteImageURL",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "containImage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "noteSize",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bc2ce1d7c4f21084014b1f28ab12d0dc",
    "id": null,
    "metadata": {},
    "name": "WANotePreviewQuery",
    "operationKind": "query",
    "text": "query WANotePreviewQuery(\n  $input: PreviewWidgetNoteInput!\n  $storecastId: ID!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetNote(input: $input) {\n      ...WidgetNote_widgetNote\n      id\n    }\n    id\n  }\n}\n\nfragment NoteNative_note on Note {\n  id\n  editingMode\n  isOrgNote\n  title\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment NoteWeb_note on Note {\n  id\n  title\n  isOrgNote\n  noteSize\n  editingMode\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    includedInSlideshow\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment WidgetNotePageBackground_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  image {\n    id\n    largeImage: size(minHeight: 1080, minWidth: 1080) {\n      url\n      height\n      width\n      id\n    }\n  }\n  imageScale\n  imageTranslateX\n  imageTranslateY\n  remoteImageURL\n  containImage\n}\n\nfragment WidgetNotePage_widgetNotePage on WidgetNotePage {\n  id\n  currentValue\n  version\n  ...useNoteWidgetStyleText_widgetNotePage\n  ...WidgetNotePageBackground_widgetNotePage\n}\n\nfragment WidgetNote_widgetNote on WidgetNote {\n  id\n  note {\n    editingMode\n    isOrgNote\n    pages {\n      id\n    }\n    ...NoteWeb_note\n    ...NoteNative_note\n    id\n  }\n}\n\nfragment useNoteWidgetStyleText_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  fontSize\n  fontStyle\n  fontColor\n  image {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "735f920b17236d1f4cef6015c8c0de25";

export default node;
